const UnionMatchRouter = {
  path: '/union-match',
  name: 'UnionMatch',
  redirect: '/union-match/home',
  component: () => import('@/views/union-match/index'),
  children: [
    {
      path: 'match-overall',
      name: 'MatchOverall',
      component: () => import('@/views/union-match/match-overall'),
      meta: { title: '赛事总览' }
    },
    {
      path: 'order-detail/:orderId',
      name: 'OrderDetail',
      component: () => import('@/views/union-match/order-detail'),
      meta: { title: '订单详情' }
    },
    {
      path: 'home',
      name: 'UnionMatchHome',
      component: () => import('@/views/union-match/home'),
      meta: { title: '赛事首页' }
    },
    {
      path: 'claim-team',
      name: 'UnionMatchClaimTeam',
      component: () => import('@/views/union-match/claim-team'),
      meta: { title: '报名信息认领' }
    },
    {
      path: 'manage-match-list',
      name: 'UnionMatchManageMatchList',
      component: () => import('@/views/union-match/manage-match-list'),
      meta: { title: '管理赛事列表' }
    }
  ]
}
export default UnionMatchRouter
